import { render } from "./ProfSearcher.vue?vue&type=template&id=1d74d40a&scoped=true"
import script from "./ProfSearcher.vue?vue&type=script&lang=js"
export * from "./ProfSearcher.vue?vue&type=script&lang=js"

import "./ProfSearcher.vue?vue&type=style&index=0&id=1d74d40a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d74d40a"]])

export default __exports__